/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PatternMatchType } from './PatternMatchType';
import {
    PatternMatchTypeFromJSON,
    PatternMatchTypeFromJSONTyped,
    PatternMatchTypeToJSON,
    PatternMatchTypeToJSONTyped,
} from './PatternMatchType';
import type { PasswordValidationRuleName } from './PasswordValidationRuleName';
import {
    PasswordValidationRuleNameFromJSON,
    PasswordValidationRuleNameFromJSONTyped,
    PasswordValidationRuleNameToJSON,
    PasswordValidationRuleNameToJSONTyped,
} from './PasswordValidationRuleName';
import type { PatternQualifier } from './PatternQualifier';
import {
    PatternQualifierFromJSON,
    PatternQualifierFromJSONTyped,
    PatternQualifierToJSON,
    PatternQualifierToJSONTyped,
} from './PatternQualifier';

/**
 * 
 * @export
 * @interface RegexPasswordValidationRule
 */
export interface RegexPasswordValidationRule {
    /**
     * 
     * @type {PasswordValidationRuleName}
     * @memberof RegexPasswordValidationRule
     */
    name: PasswordValidationRuleName;
    /**
     * 
     * @type {string}
     * @memberof RegexPasswordValidationRule
     */
    pattern: string;
    /**
     * 
     * @type {PatternMatchType}
     * @memberof RegexPasswordValidationRule
     */
    match_type: PatternMatchType;
    /**
     * 
     * @type {Array<PatternQualifier>}
     * @memberof RegexPasswordValidationRule
     */
    pattern_qualifiers?: Array<PatternQualifier>;
}



/**
 * Check if a given object implements the RegexPasswordValidationRule interface.
 */
export function instanceOfRegexPasswordValidationRule(value: object): value is RegexPasswordValidationRule {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('pattern' in value) || value['pattern'] === undefined) return false;
    if (!('match_type' in value) || value['match_type'] === undefined) return false;
    return true;
}

export function RegexPasswordValidationRuleFromJSON(json: any): RegexPasswordValidationRule {
    return RegexPasswordValidationRuleFromJSONTyped(json, false);
}

export function RegexPasswordValidationRuleFromJSONTyped(json: any, ignoreDiscriminator: boolean): RegexPasswordValidationRule {
    if (json == null) {
        return json;
    }
    return {
        
        'name': PasswordValidationRuleNameFromJSON(json['name']),
        'pattern': json['pattern'],
        'match_type': PatternMatchTypeFromJSON(json['match_type']),
        'pattern_qualifiers': json['pattern_qualifiers'] == null ? undefined : ((json['pattern_qualifiers'] as Array<any>).map(PatternQualifierFromJSON)),
    };
}

export function RegexPasswordValidationRuleToJSON(json: any): RegexPasswordValidationRule {
    return RegexPasswordValidationRuleToJSONTyped(json, false);
}

export function RegexPasswordValidationRuleToJSONTyped(value?: RegexPasswordValidationRule | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': PasswordValidationRuleNameToJSON(value['name']),
        'pattern': value['pattern'],
        'match_type': PatternMatchTypeToJSON(value['match_type']),
        'pattern_qualifiers': value['pattern_qualifiers'] == null ? undefined : ((value['pattern_qualifiers'] as Array<any>).map(PatternQualifierToJSON)),
    };
}

